import { environment } from 'environments/environment';

const MODULE_LABELS: Record<string, string> = {
    vente: 'Vente',
    achat: 'Achat',
    gestion_stock: 'Gestion stock',
    'gestion-stock': 'Gestion stock',
};

/** Libellé du module ERP courant (onglet + barre de titre). */
export function getErpModuleDisplayLabel(): string {
    const id = String((environment as { currentModule?: string }).currentModule ?? '').trim();
    if (!id) {
        return 'ERP';
    }
    return MODULE_LABELS[id] ?? MODULE_LABELS[id.replace(/-/g, '_')] ?? id;
}

/** « Vente · Devis » ou « Gestion stock » si pas de section. */
export function buildErpPageHeading(sectionTitle?: string | null): string {
    const module = getErpModuleDisplayLabel();
    const section = String(sectionTitle ?? '').trim();
    if (!section) {
        return module;
    }
    if (section.startsWith(`${module} · `)) {
        return section;
    }
    return `${module} · ${section}`;
}

/** Retire le préfixe module pour éviter les doublons. */
export function stripErpModulePrefixFromHeading(fullTitle: string): string {
    const module = getErpModuleDisplayLabel();
    const t = String(fullTitle ?? '').trim();
    const prefix = `${module} · `;
    if (t.startsWith(prefix)) {
        return t.slice(prefix.length).trim();
    }
    return t;
}
